
export default (setAmbassadors: Function) => (args: {_id: string, slug: string, fullName: string, email: string, phone: string,}) => {
  setAmbassadors((ps: any) => [...ps, {
    _id: args._id,
    slug: args.slug,
    fullName: args.fullName,
    email: args.email,
    phone: args.phone,
  }]);
}